import type { RouteId } from './types';

type AcademyGame = Extract<RouteId, 'game1' | 'game2' | 'game3'>;
const KEY = 'cca.academy-completed.v1';
const GAMES: readonly AcademyGame[] = ['game1', 'game2', 'game3'];
const completed = new Set<AcademyGame>();
let accountKey: string | undefined;
let celebrationSeen = false;

/** Local celebration progress only; CMS records remain server-authoritative.
 * Never share one student's celebration with another on a classroom device. */
export function setAcademyProgressAccount(accountId: string): void {
  completed.clear();
  celebrationSeen = false;
  accountKey = accountId.trim() ? `${KEY}:${encodeURIComponent(accountId)}` : undefined;
  if (!accountKey) return;
  try {
    const saved: unknown = JSON.parse(globalThis.localStorage.getItem(accountKey) ?? '[]');
    if (Array.isArray(saved)) for (const id of saved) {
      if (GAMES.includes(id as AcademyGame)) completed.add(id as AcademyGame);
    }
  } catch {
    // The current page can still track completion when storage is unavailable.
  }
}

export function markAcademyGameComplete(game: AcademyGame): void {
  completed.add(game);
  try { if (accountKey) globalThis.localStorage.setItem(accountKey, JSON.stringify([...completed])); }
  catch { /* Keep completion for this page lifetime. */ }
}

export function academyComplete(): boolean {
  return GAMES.every((game) => completed.has(game));
}

/** Offer after all first attempts, and again on each authenticated app visit.
 * Only the completed attempts persist; acknowledgement lasts for this visit. */
export function academyCelebrationPending(): boolean {
  return academyComplete() && !celebrationSeen;
}

export function markAcademyCelebrationSeen(): void {
  celebrationSeen = true;
}
